import { render } from "./RecordType.vue?vue&type=template&id=3f77ceea&scoped=true"
import script from "./RecordType.vue?vue&type=script&lang=js"
export * from "./RecordType.vue?vue&type=script&lang=js"

import "./RecordType.vue?vue&type=style&index=0&id=3f77ceea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f77ceea"]])

export default __exports__